import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-company-data-required',
  standalone: false,
  templateUrl: './company-data-required.component.html'
})
export class CompanyDataRequiredComponent {
  goToProfile(): void {
    const url = new URL(`${environment.platformWebUrl.replace(/\/$/, '')}/profile`);
    url.searchParams.set('section', 'company');
    window.location.href = url.toString();
  }
}
